module.exports = __webpack_public_path__ + "static/media/IndianaJones.3bc641cb.png";